// Which SP4 surfaces this merchant has enabled, from the SSI-injected
// `portal-next.json` snapshot (see index.html `#portalNext`):
//
//   home — SP4 renders the Home route's content (Sp4HomeBridge).
//   shell — with `home`, SP4 owns the page chrome on every route (Sp4Layout) and the
//          Pro layout is never rendered. Ignored without `home`.
//
// Anything missing, invalid or non-boolean fails closed to the legacy shell.
const DISABLED_SP4_SURFACES = Object.freeze({ home: false, shell: false });

const isExplicitlyEnabled = (value, surface) =>
    value !== null &&
    typeof value === 'object' &&
    !Array.isArray(value) &&
    value[surface] === true;

export const normalizeSp4SurfaceRollout = (value) => {
    const home = isExplicitlyEnabled(value, 'home');
    return Object.freeze({
        home,
        shell: home && isExplicitlyEnabled(value, 'shell'),
    });
};

export const readInjectedSp4SurfaceRollout = (
    documentImpl = globalThis.document,
) => {
    const raw = documentImpl
        ?.getElementById('portalNext')
        ?.textContent?.trim();

    if (!raw) {
        return null;
    }

    try {
        return JSON.parse(raw);
    } catch {
        return null;
    }
};

export const createSp4SurfaceRollout = (readConfig) => {
    let snapshot = DISABLED_SP4_SURFACES;
    let initialized = false;

    return {
        initialize: () => {
            if (!initialized) {
                initialized = true;

                try {
                    snapshot = normalizeSp4SurfaceRollout(readConfig());
                } catch {
                    snapshot = DISABLED_SP4_SURFACES;
                }
            }

            return snapshot;
        },
        isEnabled: (surface) => snapshot[surface] === true,
    };
};

const currentRollout = createSp4SurfaceRollout(
    readInjectedSp4SurfaceRollout,
);

export const initializeSp4SurfaceRollout = () => currentRollout.initialize();
export const isSp4SurfaceEnabled = (surface) =>
    currentRollout.isEnabled(surface);
